import { render, staticRenderFns } from "./BatchTransferList.template.vue?vue&type=template&id=47334a76&scoped=true&"
var script = {}
import style0 from "./BatchTransferList.template.vue?vue&type=style&index=0&id=47334a76&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47334a76",
  null
  
)

export default component.exports